import { useState, useEffect } from "react";
import { Image, Box, Grid, GridItem, Link } from "@chakra-ui/react";
import ImageModal from "./StatImgModal";

export default function GridStatView({ images, gridConfig, titles }) {
    const [imageList, setImageList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [selectedTitle, setSelectedTitle] = useState("");
    useEffect(() => {
        if (Array.isArray(images)) {
            setImageList(images);
        } else {
            console.warn("GridStatView: Received non-array images prop", images);
            setImageList([]);
        }
    }, [images]);
    const defaultGridConfig = [
        { colSpan: 1, rowSpan: 1, ratio: 0.80 }, // Reduced ratio for smaller images
        { colSpan: 1, rowSpan: 1, ratio: 0.80 }, // Reduced ratio for smaller images
        { colSpan: 1, rowSpan: 1, ratio: 0.80 }, // Reduced ratio for smaller images
        { colSpan: 1, rowSpan: 1, ratio: 0.80 }, // Reduced ratio for smaller images
    ];
    const config = gridConfig || defaultGridConfig;
    const handleImageClick = (image, index) => {
        let imageTitle = "Statistical Data";
        if (titles && titles[index]) {
            imageTitle = titles[index];
        }
        setSelectedImage(image);
        setSelectedTitle(imageTitle);
        setIsModalOpen(true);
    };
    return (
        <>
            <Grid templateColumns="repeat(2, 1fr)" templateRows="repeat(1, 1fr)" gap={4} width="100%" height="100%">
                {imageList.map((image, index) => {
                    const itemConfig = index < config.length ? config[index] : defaultGridConfig[0];
                    return (
                        <GridItem key={index} colSpan={itemConfig.colSpan} rowSpan={itemConfig.rowSpan} position="relative" overflow="hidden" borderRadius="md" border="1px solid" borderColor="gray.200" height="100%" cursor="pointer" _hover={{ boxShadow: "lg", borderColor: "#0b4e5a" }}>
                            <Link onClick={(e) => { e.preventDefault(); handleImageClick(image, index); }} display="block" height="100%" width="100%">
                                <Box position="relative" width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" overflow="hidden" p={3}>
                                    <Image src={image} alt={`Stat ${index + 1}`} objectFit="contain" width="85%" height="85%" transform={`scale(${itemConfig.ratio})`} />
                                </Box>
                            </Link>
                        </GridItem>
                    );
                })}
            </Grid>
            <ImageModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} imageSrc={selectedImage} title={selectedTitle} />
        </>
    );
}
